/**
 * Stable per-browser-installation identity for the EMR portal. A practitioner may be
 * signed in on several devices at once — this id (generated once, persisted in
 * localStorage) is what tells them apart in EMR check-in logs and remote-debug command
 * results. Parse/storage failures degrade to null rather than throwing: identity is
 * never allowed to break the feature that asked for it.
 */

const DEVICE_ID_STORAGE_KEY = 'emrClientDeviceId'

function generateDeviceId() {
  const random =
    typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID().replace(/-/g, '')
      : `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`
  return `DEV-${random}`
}

export function getOrCreateEmrDeviceId() {
  try {
    let deviceId = localStorage.getItem(DEVICE_ID_STORAGE_KEY)
    if (!deviceId) {
      deviceId = generateDeviceId()
      localStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId)
    }
    return deviceId
  } catch (error) {
    return null
  }
}

/** Friendly label for support UIs, e.g. "Chrome on Windows · desktop". */
export function buildEmrDeviceLabel(clientDeviceInfo) {
  if (!clientDeviceInfo) {
    return 'Unknown device'
  }
  const parts = [clientDeviceInfo.browserName || 'Browser']
  if (clientDeviceInfo.osName) {
    parts.push(`on ${clientDeviceInfo.osName}`)
  }
  const label = parts.join(' ')
  return clientDeviceInfo.deviceType ? `${label} · ${clientDeviceInfo.deviceType}` : label
}
